import axios from "axios";

export default {
  actions: {
    postAsync: ({ commit }, { path, formData }) => {
      return new Promise((resolve, reject) => {
        formData.append("format", "json");
        axios.post(path, formData).then(response => {
          const { data } = response;
          if (data.notice) {
            flash({ type: "notice", message: data.notice, commit });
            resolve();
          } else if (data.error) {
            flash({ type: "error", message: data.error, commit });
            reject();
          }
        });
      });
    },
    setCurrentLocale: ({ commit }, data) => commit("setCurrentLocale", data),
    setCurrentCityUrl: ({ commit }, data) => commit("setCurrentCityUrl", data),
    setCsrfToken: ({ commit }, data) => commit("setCsrfToken", data),
    toggleNavigationState: ({ commit }, data) => commit("toggleNavigationState", data),
    setGlobalToggle: ({ commit }, data) => commit("setGlobalToggle", data),
    showModal: ({ commit }, modalName) => commit("showModal", modalName),
    hideModal: ({ commit }, modalName) => commit("hideModal", modalName),
    fetchCsrfToken: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios
          .get(`/users/csrf_token.json`)
          .then(response => commit("setCsrfToken", { token: response.data.data, resolve, reject }))
          .catch(error => flashError(error, commit));
      });
    },
  },
  getters: {
    getCsrfToken: state => state.csrfToken,
    getCurrentLocale: state => state.currentLocale,
    getCurrentCityUrl: state => state.currentCityUrl,
    getNavigationOpenState: state => state.navigationOpen,
    getOpenModals: state => state.openModals,
    getGlobalToggles: state => state.globalToggles,
  },
  mutations: {
    setGlobalToggle: (state, data) => {
      state.globalToggles = {
        ...state.globalToggles,
        [data.key]: data.value,
      };
    },
    setCurrentLocale: (state, locale) => {
      state.currentLocale = locale;
    },
    setCurrentCityUrl: (state, url) => {
      state.currentCityUrl = url;
    },
    setCsrfToken: (state, { token, resolve }) => {
      state.csrfToken = token;
      resolve();
    },
    toggleNavigationState: state => {
      state.navigationOpen = !state.navigationOpen;
    },
    showModal: (state, modalName) => {
      state.openModals = [...new Set([...state.openModals]).add(modalName)];
    },
    hideModal: (state, modalName) => {
      const openModals = new Set([...state.openModals]);
      openModals.delete(modalName);
      state.openModals = [...openModals];
    },
  },
  state: {
    csrfToken: "",
    currentLocale: "",
    currentCityUrl: "",
    navigationOpen: false,
    openModals: [],
    globalToggles: {},
  },
};

const flash = ({ type, message, commit }) =>
  commit("flashMessages/setMessages", [[type, message]], {
    root: true,
  });

const flashError = (error, commit) =>
  commit("flashMessages/setMessages", [["error", error.response.data.error]], {
    root: true,
  });
